module.exports = require("core-js-pure/features/instance/filter");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/filter.js
// module id = 475
// module chunks = 13